module.exports = __webpack_public_path__ + "static/home-about-bg-e950f09d419e975942acd8fb5fefa37d.png";